import React, { Suspense, lazy, Fragment } from 'react';
import LazyLoader from '../components/MasterLayout/LazyLoader';
import MasterLayout from '../components/MasterLayout/MasterLayout';
const  Canceled =lazy(() => import('../components/Canceled/Canceled'))

const CanceledPage = () => {
    return (
        <Fragment>
            <MasterLayout>
            <Suspense fallback={<LazyLoader/>}>
            <Canceled/>
            </Suspense>
            </MasterLayout>
        </Fragment>
    );
};

export default CanceledPage;